module.exports = __webpack_public_path__ + "96e5c33b1d41013289a9808f4279da0b.mp3";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/gewonnen_level_6_opgewekt.mp3
// module id = 99
// module chunks = 0